<template>
    <div class="members-cover">
        <div class="baseAccordion">
        <BaseAccordion>
            <template v-slot:name>
                {{$t('outbound_sport_cover_winter_name')}}
                <label class="form-switch" @click.stop>
                    <input type="checkbox" v-model="switchAdditional">
                    <i></i>
                </label>
            </template>
            <template v-slot:content>
              <slot name="insuredList">
              </slot>
            </template>
        </BaseAccordion>
        </div>
    </div>
</template>

<script>
import BaseAccordion from '../BaseAccordion.vue'
export default {
  name: 'MemberAdditionalCover',
  components: {
    BaseAccordion
  },
  props: {
    value: {
      type: Boolean
    }
  },
  computed: {
    switchAdditional: {
      get () {
        return this.value
      },
      set (val) {
        return this.$emit('input', val)
      }
    }
  }
}
</script>
